import React from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import LandingPage from './components/LandingPage';

import AdminLoginModule from './components/Adminfiles/AdminLoginModule';
import AdminDashboard from './components/Adminfiles/AdminDashboard';

import VendorLoginModule from './components/Vendorfiles/VendorLoginModule';
import VendorMain from './components/Vendorfiles/VendorMain';

import RecruiterLogin from './components/recruiterfiles/RecruiterLogin';
import RecruiterDashboard from './components/recruiterfiles/RecruiterDashboard';

import CandidateAuth from './components/candidatefiles/CandidateAuth';
import CandidateProfile from './components/candidatefiles/CandidateProfile';
import ApplicationTracker from './components/candidatefiles/ApplicationTracker';
import CandidateAssessment from './components/candidatefiles/CandidateAssessment';

const backButtonStyle = {
  position: 'fixed', top: '20px', left: '20px', padding: '8px 16px',
  background: 'white', border: '1px solid #ccc', borderRadius: '4px',
  cursor: 'pointer', zIndex: 1000, fontWeight: 'bold', color: '#333',
  display: 'flex', alignItems: 'center', gap: '5px',
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
};

function BackHome() {
  const navigate = useNavigate();
  return (
    <button onClick={() => navigate('/')} style={backButtonStyle}>
      <span>←</span> Home
    </button>
  );
}

function AdminLoginPage() {
  const navigate = useNavigate();
  return (
    <div className="module-container">
      <BackHome />
      <AdminLoginModule onLoginSuccess={() => navigate('/admin/dashboard')} />
    </div>
  );
}

function VendorLoginPage() {
  const navigate = useNavigate();
  return (
    <div className="module-container">
      <BackHome />
      <VendorLoginModule onLoginSuccess={() => navigate('/vendor/dashboard')} />
    </div>
  );
}

function RecruiterLoginPage() {
  const navigate = useNavigate();
  return (
    <div className="module-container">
      <BackHome />
      <RecruiterLogin onLoginSuccess={() => navigate('/recruiter/dashboard')} />
    </div>
  );
}

function CandidateAuthPage() {
  const navigate = useNavigate();
  return (
    <div className="module-container">
      <BackHome />
      <CandidateAuth onLoginSuccess={() => navigate('/candidate/dashboard')} />
    </div>
  );
}

function withLogout(Component) {
  return function Wrapped() {
    const navigate = useNavigate();
    const handleLogout = () => {
      localStorage.clear();
      navigate('/');
    };
    return <Component onLogout={handleLogout} />;
  };
}

const AdminDashboardPage = withLogout(AdminDashboard);
const VendorDashboardPage = withLogout(VendorMain);
const RecruiterDashboardPage = withLogout(RecruiterDashboard);
const CandidateDashboardPage = withLogout(CandidateProfile);

function LandingRoute() {
  const navigate = useNavigate();
  return (
    <LandingPage
      onNavigateAdmin={() => navigate('/admin')}
      onNavigateVendor={() => navigate('/vendor')}
      onNavigateRecruiter={() => navigate('/recruiter')}
      onNavigateCandidate={() => navigate('/candidate')}
    />
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingRoute />} />

        <Route path="/admin" element={<AdminLoginPage />} />
        <Route path="/admin/dashboard" element={<AdminDashboardPage />} />

        <Route path="/vendor" element={<VendorLoginPage />} />
        <Route path="/vendor/dashboard" element={<VendorDashboardPage />} />

        <Route path="/recruiter" element={<RecruiterLoginPage />} />
        <Route path="/recruiter/dashboard" element={<RecruiterDashboardPage />} />

        <Route path="/candidate" element={<CandidateAuthPage />} />
        <Route path="/candidate/register" element={<CandidateAuthPage />} />
        <Route path="/candidate/dashboard" element={<CandidateDashboardPage />} />

        <Route path="/tracker" element={<ApplicationTracker />} />
        <Route path="/assessment/:id" element={<CandidateAssessment />} />
      </Routes>
    </BrowserRouter>
  );
}


export default App;
